import { lazy } from "react";

const WebsitePolicies = lazy(
  () => import("../../Layouts/Footer/screens/WebsitePolicies/index")
);

const FooterContact = lazy(
  () => import("../../Layouts/Footer/screens/FooterContact")
);
const Feedback = lazy(() => import("../../Layouts/Footer/screens/Feedback"));

const Sitemap = lazy(() => import("../../Layouts/Footer/screens/Sitemap"));

const WebinfoManager = lazy(
  () => import("../../Layouts/Footer/screens/WebinfoManager")
);
const AboutWebsite = lazy(
  () => import("../../Layouts/Footer/screens/AboutWebsite")
);
const HelpSection = lazy(
  () => import("../../Layouts/Footer/screens/HelpSection")
);

export {
  WebsitePolicies,
  FooterContact,
  Feedback,
  Sitemap,
  WebinfoManager,
  AboutWebsite,
  HelpSection,
};
